import { TTaskType } from "src/data/taskManagement/taskManagementTypes"

import { usePostTrackEventWithParams } from "./analyticsQueries"

export type TTaskFilterType = "unit" | "assignee"

type TTaskEventTypes =
  | "Create Task Initiated"
  | "Task Created"
  | "Task Filters Viewed"
  | "Task Filters Applied"
  | "Task Searched"
  | "Task Beta Viewed"
  | "Enroll Tasks Beta"

function usePostTaskTrackingEvent<TEventProperties>(event: TTaskEventTypes) {
  const postTrackEvent = usePostTrackEventWithParams<
    TTaskEventTypes,
    TEventProperties
  >({
    event,
  })
  return postTrackEvent
}

export function usePostCreateTaskInitiated() {
  const x = usePostTaskTrackingEvent("Create Task Initiated")

  return { ...x, mutate: () => x.mutate({}) }
}

export function usePostTaskCreated() {
  const postTaskCreated = usePostTaskTrackingEvent<{
    task_type: TTaskType
  }>("Task Created")
  return postTaskCreated
}

export function usePostTaskFiltersViewed() {
  const postTaskFiltersViewed = usePostTaskTrackingEvent<{
    filter_type: TTaskFilterType
  }>("Task Filters Viewed")

  return postTaskFiltersViewed
}

export function usePostTaskFiltersApplied() {
  const postTaskFiltersApplied = usePostTaskTrackingEvent<{
    filter_type: TTaskFilterType
  }>("Task Filters Applied")

  return postTaskFiltersApplied
}

export function usePostTaskSearched() {
  const postTaskSearched = usePostTaskTrackingEvent<{
    search_text: string
  }>("Task Searched")

  return postTaskSearched
}

export function usePostTrackingBetaEnrolledEvent() {
  const postBetaEnroll = usePostTaskTrackingEvent<{
    challenges: string
    benefits: string
    teamSize: string
    copy: "A" | "B"
  }>("Enroll Tasks Beta")
  return postBetaEnroll
}

export function useTaskBetaViewed() {
  const postTaskBetaViewed = usePostTaskTrackingEvent<{
    copy: "A" | "B"
  }>("Task Beta Viewed")
  return postTaskBetaViewed
}
